import React, { useState } from 'react'
import { isEmpty } from 'lodash'

import { getRepeatResult, cutString2, colorThemeSelector } from '../../../../helpers/functions'
import { REPEAT_BOOKING, CREATE_BOOKING, BOOKING_MODAL, MEETING_LINK_TYPE } from '../../../../helpers/constants'
import { IMG } from '../../../../themes'

import Bullet from '../Bullet'
import EditIcon from './EditIcon'
import DeleteIcon from './DeleteIcon'
import CopyIcon from '../../../CopyIcon'
import ToastCopy from '../../../ToastCopy'

const BookingViewModal = (props) => {
  const {
    language,
    selectedBooking,
    permission,
    onUpdate,
    onConfirm,
    onClose,
    colorTheme,
    handleSelectBookingDetail,
    handleClickCopy,
    isClickCopy,
    closeToast,
    companyTokenType,
  } = props

  const bullet = <Bullet colorTheme={colorTheme} />

  const ViewBookingDetailButton = ({ selectedBooking, permission, onUpdate }) => {
    const hasPermission = permission.update && selectedBooking

    const colorThemeValue = colorThemeSelector(colorTheme)

    const buttonStyle = {
      cursor: hasPermission ? 'pointer' : 'not-allowed',
      backgroundColor: colorThemeValue.MAIN,
      color: colorThemeValue.FONT_COLOR.TEXT,
    }

    return (
      <div className='view-booking__button'>
        <button
          style={buttonStyle}
          onClick={() => handleSelectBookingDetail(selectedBooking.id)}
        >
          {BOOKING_MODAL.VIEW_BOOKING_DETAIL[language]}
        </button>
      </div>
    )
  }

  const Booking = ({ item }) => {
    return (
      <div>
        <div className='title'>
          {bullet}
          <span>{cutString2(item.title, 25)}</span>
        </div>

        <div className='detail'>
          <img src={IMG['calendar.svg']} alt='calendar' />
          <span>{item.day}</span>
        </div>

        <div className='detail'>
          <img src={IMG['location.svg']} alt='location' />
          <span>{cutString2(item.location, 25)}</span>
        </div>

        <div className='detail'>
          <img src={IMG['time.svg']} alt='time' />
          <span>{item.time}</span>
        </div>

        <div className='detail'>
          <img src={IMG['account.svg']} alt='account' />
          <span>{item.owner}</span>
        </div>

        <div className='detail'>
          <img src={IMG['detail.svg']} alt='detail' />
          <span>{cutString2(item.description, 25)}</span>
        </div>

        <div className='detail'>
          <img src={IMG['ic_repeat.svg']} alt='repeat-booking' />
          <span>{`${REPEAT_BOOKING.REPEAT_TITLE[language]} ${getRepeatResult(item.recurrence, language)}`}</span>
        </div>

        <div className='detail'>
          <img src={IMG['link.svg']} alt='link' />
          {item.meetingLink && item.meetingLink.trim().length !== 0 ? 
          <div className='two-lines'><a className='link-icon' href={item.meetingLink} target='_blank'>{item.meetingLink}</a> </div>
          : <span> - </span>}
          {item.meetingLink && item.meetingLink.trim().length !== 0 ? 
          <button className='copy-link-button' onClick={() => handleClickCopy(item.meetingLink)}>
          <CopyIcon color={colorTheme}/>
          </button>:null}
        </div>
        <ToastCopy
          isOpenToast={isClickCopy}
          onClickCloseToast={() => closeToast()}
          language={language}
        />

        <ViewBookingDetailButton
          selectedBooking={selectedBooking}
          permission={permission}
          onUpdate={onUpdate}
        />
      </div>
    )
  }

  return (
    <div className='card'>
      <div className='data-list'>
        <div className='action-button'>
          
          <EditIcon
            selectedBooking={selectedBooking}
            permission={permission}
            onUpdate={onUpdate}
          />

          <DeleteIcon
            selectedBooking={selectedBooking}
            permission={permission}
            onConfirm={onConfirm}
            language={language}
            companyTokenType={companyTokenType}
          />

          <img src={IMG['close.svg']} onClick={onClose} alt='close' />
        </div>

        {!isEmpty(selectedBooking)
          ? <Booking key='booking-view' item={selectedBooking} />
          : (
            <div className='title'>
              {bullet}
              <span>{CREATE_BOOKING.NO_DATA[language]}</span>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default BookingViewModal
